module.exports = __webpack_public_path__ + "static/img/status.cc184b8f.png";